module.exports = __webpack_public_path__ + "h5/img/icon-vip.159f3fe7.png";